module.exports = __webpack_public_path__ + "static/media/29DUNON6.c037d9fd.jpg";